const ITEMS = [
  "MOT countdowns",
  "Council test alerts",
  "Road tax deadlines",
  "Email reminders",
  "Passcode security",
  "Small-fleet ready",
];

function Row({ hidden }) {
  return (
    <div className="flex items-center shrink-0" aria-hidden={hidden || undefined}>
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center">
          <span className="px-8 font-display text-2xl md:text-4xl font-bold uppercase tracking-wide text-hi/75 whitespace-nowrap">
            {t}
          </span>
          <span className="font-mono text-ember text-lg md:text-xl">///</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section className="border-y border-line bg-panel/40 py-6 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
